import { API } from '..';

// Admin chỉnh cấu hình hệ thống (quy tắc tiền tệ...). Backend: cab-payment-service, route admin qua gateway.
const BASE = '/v1/payment-service/admin/system';

export interface SettingItem {
  key: string;
  group: string;
  kind: 'int' | 'decimal' | 'bool' | 'text';
  label: string;
  unit?: string | null;
  value: string;
  sensitive: boolean; // nhóm tiền tệ: cần SuperAdmin + mã Authenticator khi đổi
}

export const getSystemConfig = () =>
  API.get<{ items: SettingItem[] }>(`${BASE}/config`).then((r) => r.data.items);

// totpCode: mã Authenticator, chỉ cần khi đổi key nhạy cảm (tiền tệ).
export const setSystemConfig = (values: Record<string, string>, totpCode?: string) =>
  API.post(`${BASE}/config`, { values }, { params: totpCode ? { totpCode } : {} }).then((r) => r.data);
